import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import SiteLayout from './layouts/SiteLayout';
import Home from './pages/Home';
import { ContentPage, Departments, DetailPage, Doctors, DropdownLanding, Gallery, Services } from './pages/DirectoryPages';
import { Appointment, Contact, FAQ, NotFound, SearchPage } from './pages/UtilityPages';
import Admin from './pages/admin/Admin';
import { AboutPage, BlogPage, CareersPage, FacilitiesPage, LegalPage, NewsPage, PatientPortalPage, TestimonialsPage } from './pages/ProfessionalPages';

export default function App() {
  return <BrowserRouter><Routes>
    <Route element={<SiteLayout/>}>
      <Route index element={<Home/>}/>
      <Route path="about" element={<AboutPage/>}/>
      <Route path="facilities" element={<FacilitiesPage/>}/>
      <Route path="testimonials" element={<TestimonialsPage/>}/>
      <Route path="blog" element={<BlogPage/>}/>
      <Route path="news" element={<NewsPage/>}/>
      <Route path="careers" element={<CareersPage/>}/>
      <Route path="patient-portal" element={<PatientPortalPage/>}/>
      <Route path="privacy" element={<LegalPage type="privacy"/>}/>
      <Route path="terms" element={<LegalPage type="terms"/>}/>
      <Route path="departments" element={<Departments/>}/>
      <Route path="patient-info" element={<DropdownLanding menuLabel="Patient Info" eyebrow="Patient information" title="Plan a safe, informed hospital visit" intro="Understand your rights, hospital dining and pharmacy support before you arrive."/>}/>
      <Route path="health-packages" element={<DropdownLanding menuLabel="Health Check Packages" eyebrow="Preventive health" title="Health checks for every stage of life" intro="Choose a focused preventive package and review its tests, preparation and consultation guidance."/>}/>
      <Route path="doctors" element={<Doctors/>}/>
      <Route path="services" element={<Services/>}/>
      <Route path="gallery" element={<Gallery/>}/>
      <Route path="appointment" element={<Appointment/>}/>
      <Route path="contact" element={<Contact/>}/>
      <Route path="faq" element={<FAQ/>}/>
      <Route path="search" element={<SearchPage/>}/>
      <Route path="specialties/:slug" element={<DetailPage type="specialty"/>}/>
      <Route path="about/:slug" element={<DetailPage type="about"/>}/>
      <Route path="patient-info/:slug" element={<DetailPage type="patient"/>}/>
      <Route path="health-packages/:slug" element={<DetailPage type="package"/>}/>
      <Route path="*" element={<NotFound/>}/>
    </Route>
    <Route path="/admin/*" element={<Admin/>}/>
  </Routes></BrowserRouter>;
}
